export const dateView = {
  yearMonthDay: ["year", "month", "day"],
  year: ["year"],
};
